// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__zfhso","open":"Sidebar_open__uSeyZ","menuItem":"Sidebar_menuItem__QA9Di"};